export default "__VITE_ASSET__f369006a__"